import { useEffect } from 'react';
import styles from './style.module.scss';
import { Col, Row, Space, Spin, Table, Typography } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { Chart } from 'react-google-charts';
import useFootfall from '../useFootfall';
import { useTranslation } from 'react-i18next';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import moment from 'moment';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    title,
    searchParams,
    format,
    loading,
    summary,
    filters,
  } = useFootfall(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <br />
            {!allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>{title}</Typography.Title>
                </Col>
                <PrintFilterText
                  availableFilters={availableFilters}
                  searchParams={searchParams}
                />
              </Row>
            )}
            {allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>Footfall</Typography.Title>
                </Col>
              </Row>
            )}
            <br />
            <Row>
              <Col span={24}>
                <Table
                  columns={columns}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                  summary={summary}
                />
              </Col>
              <Col span={24}>
                <Row className={'chartColl'}>
                  <Col span={12}>
                    <LineChart
                      data={data.lineChartData}
                      tableData={data.tableData}
                      colors={['#61cdbb', '#f47560']}
                    />
                    <BarChangeChart
                      data={data}
                      format={format}
                      keys={['Footfall LY', 'Footfall YTD']}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default Print;
